import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Tooltip } from "@revvsales/components";
import { Button, Loader } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DocumentReviewListTag from "./DocumentReviewListTag";

// Action imports
import { getDocAnalysis } from "../../../../actions/MetalensActions/metalensActions";

// Internal imports
import { clauseTypes, spotlight } from "../../../../constants/metalens";
import DocumentReviewSpotlightTag from "./DocumentReviewSpotlightTag";

const DocumentReviewListing = ({
  getDocAnalysisAction,
  docID,
  activateClauses,
  active,
  sharingHash,
  isLatestAnalysis,
}) => {
  const [dataLoading, setDataLoading] = useState(false);
  const [reAnalyseLoader, setReAnalyseLoader] = useState(false);

  useEffect(
    () => {
      setDataLoading(true);
      getDocAnalysisAction(docID, sharingHash)
        .then(() => {
          setDataLoading(false);
        })
        .catch(err => {
          setDataLoading(false);
          console.debug(err);
        });
    },
    [docID, getDocAnalysisAction, sharingHash],
  );

  return (
    <div
      className={`documentreviewlisting ${
        active ? "" : "documentreviewsection-inactive"
      }`}>
      <div className="documentreviewlisting-head">
        Review document by Type
        {/* <Tooltip
          placement="top"
          overlayClassName=""
          align={{
            offset: [0, 4],
          }}
          overlay="Metalens identifies and highlights data in the document such as names, dates, amounts, and more">
          <span className="documentreviewsection-info-circle">
            <FontAwesomeIcon icon={["far", "info-circle"]} className="" />
          </span>
        </Tooltip> */}
      </div>

      <div className="documentreviewlisting-body">
        {dataLoading && (
          <div className="documentreviewlisting-body-loader">
            <Loader label="⚡ Running RevvAI to analyze this document" />
          </div>
        )}
        {/* Reanalyse */}
        {!isLatestAnalysis && (
          <div className="metalens-detect-action">
            {reAnalyseLoader && (
              <Loader
                label="Re-analyzing this document"
                className="metalens-detect-loading"
                fullScreen={false}
              />
            )}
            <div className="metalens-detect-info">
              <span className="metalens-detect-info-icon">
                <FontAwesomeIcon
                  icon={["far", "engine-warning"]}
                  className=""
                />
              </span>{" "}
              Changes detected. Re-analysing the doc might lose your
              customisation.
            </div>
            <Button
              data-test="documentreviewlisting-btn-reanalyze"
              className="metalens-btn-add-tag metalens-detect-action-btn"
              onClick={() => {
                setReAnalyseLoader(true);
                getDocAnalysisAction(docID, sharingHash)
                  .then(() => {
                    setReAnalyseLoader(false);
                  })
                  .catch(() => {
                    setReAnalyseLoader(false);
                  });
              }}
              id="metalens-action-add">
              <FontAwesomeIcon icon={["far", "sync-alt"]} className="" />
              &nbsp; Re-Analyze this doc
            </Button>
          </div>
        )}
        {!dataLoading && (
          <DocumentReviewSpotlightTag
            dataLoading={dataLoading}
            type={spotlight}
            activateClauses={activateClauses}
          />
        )}
        {clauseTypes.map(ctype => (
          <DocumentReviewListTag
            dataLoading={dataLoading}
            type={ctype}
            activateClauses={activateClauses}
            key={`clauseanalysis-${ctype.id}`}
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  DocumentStore: { document: { id: docID } = {} } = {},
  MetalensStore: { isLatestAnalysis } = {},
}) => ({
  docID,
  isLatestAnalysis,
});

const mapDispatchToProps = {
  getDocAnalysisAction: getDocAnalysis,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentReviewListing);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewListing/DocumentReviewListing.js